import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { errMsg } from "@/lib/hsUtil";
import { applyTemplate } from "@/pages/hs/TemplatesBar";

export default function HazardTemplatePrompt({ project, onDone }) {
  const [list, setList] = useState(null);
  const [tid, setTid] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/hs/hazard-templates").then(r => setList(r.data)).catch(() => setList([])); }, []);
  useEffect(() => { if (list && list.length === 0) onDone(); }, [list, onDone]);
  if (!list || list.length === 0) return null;
  async function apply() {
    setBusy(true);
    try { await applyTemplate(project.id, tid, "add"); onDone(); }
    catch (e) { toast.error(errMsg(e)); setBusy(false); }
  }
  return (
    <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" data-testid="new-job-template-prompt">
      <div className="card max-w-md w-full space-y-3">
        <h3 className="text-silver">Apply a hazard template?</h3>
        <div className="text-sm opacity-80">Optional. Ticks a saved set of hazards for {project.name}. You can change them later in H&amp;S → Project hazards.</div>
        <select className="input" value={tid} onChange={e => setTid(e.target.value)} data-testid="new-job-template-select">
          <option value="">Choose a template…</option>
          {list.map(t => <option key={t.id} value={t.id}>{t.name} ({t.hazard_count} hazards)</option>)}
        </select>
        <div className="flex gap-2">
          <button className="btn-silver" disabled={!tid || busy} onClick={apply} data-testid="new-job-template-apply">Apply template</button>
          <button className="btn-ghost" onClick={onDone} data-testid="new-job-template-skip">Skip</button>
        </div>
      </div>
    </div>
  );
}
